<app-modal-dialog #modal
    title="{{ (selectedCategory.id == '' ? 'reservationTags.category.create' : 'reservationTags.category.edit') | translate }}"
    modalId="reservation-category-tag-modal" okText="{{ 'reservationTags.category.save' | translate }}"
    [isValid]="name.invalid == false" (onClose)="categoryModalClosed($event)">
    <div class="form-col">
        <app-color-dropdown [(model)]="selectedCategory.color"></app-color-dropdown>

        <input [(ngModel)]="selectedCategory.name" required #name="ngModel" type="text" class="ihost-control w-100 mb-2"
            placeholder="{{ 'reservationTags.placeholders.tagCategory' | translate }}" />
    </div>
</app-modal-dialog>